import { buildMetadata } from "../../shared/buildInfo";

const version = buildMetadata.versions.booking;

export default {
  VERSION: buildMetadata.gitDescription.includes(version)
    ? buildMetadata.gitDescription
    : buildMetadata.gitDescription + `(${version})`,
  LAST_COMMIT_DATE_TIME: buildMetadata.commitDate,
  COMMIT_HASH: buildMetadata.commitHash,
};
